export const getThemeConfig = (mode, customColors = {}) => {
  const {
    primary = mode === 'dark' ? '#90caf9' : '#1976d2',
    secondary = mode === 'dark' ? '#f48fb1' : '#dc004e',
    background = mode === 'dark' ? '#121212' : '#fff',
    paper = mode === 'dark' ? '#1e1e1e' : '#fff',
    text = mode === 'dark' ? '#fff' : '#000',
  } = customColors;

  return {
    palette: {
      mode,
      ...(mode === 'dark'
        ? {
            // palette values for dark mode
            primary: { main: primary },
            secondary: { main: secondary },
            background: {
              default: background,
              paper: paper,
            },
            text: {
              primary: text,
              secondary: 'rgba(255, 255, 255, 0.7)',
            },
          }
        : {
            // palette values for light mode
            primary: { main: primary },
            secondary: { main: secondary },
            background: {
              default: background,
              paper: paper,
            },
            text: {
              primary: text,
              secondary: 'rgba(0, 0, 0, 0.54)',
            },
          }),
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            border: '1px solid rgba(128, 128, 128, 0.2)',
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            borderRight: '1px solid rgba(128, 128, 128, 0.2)',
          },
        },
      },
    },
  };
};